import React from 'react'
import { IMG_BASE_URL } from '../Helpers'
import a1 from '../assets/a1.png';
import a2 from '../assets/a2.png';
import SEO from '../seo/SEO';
import { AboutSEOData } from '../seo/AboutSEO';
import { bullet } from '../assets/logo_wa.png';
export default function About() {
    return (
        <>
            <SEO {...AboutSEOData} />
            <header className="">
                <div className="container px-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xxl-12">
                            <div className="text-center my-5">
                                <h1 className="fw-bolder cherry-red-heading">ഉയിർമൊഴിയുടെ ലക്ഷ്യം</h1>
                                <p className="lead fw-normal text-muted mb-4">
                                    വിജ്ഞാനത്തിന്റെ ലോകത്തേക്ക് വായനക്കാരെ കൈപിടിച്ചുയർത്തുക എന്ന മഹത്തായ ദൗത്യമാണ് ഉയിർമൊഴി ഏറ്റെടുത്തിരിക്കുന്നത്. കേവലം പുസ്തകപ്രസാധനത്തിനപ്പുറം, വരുംതലമുറയ്ക്കായി നമ്മുടെ സാംസ്കാരിക പൈതൃകം കരുതിവെക്കാനുള്ള ഒരു എളിയ ശ്രമമാണിത്. അക്ഷരങ്ങളിലൂടെ അറിവ് പകരുക എന്നതിനോടൊപ്പം തന്നെ, നമ്മുടെ നാടിന്റെ തനതായ കലകളെയും ചരിത്രത്തെയും വരുംകാലത്തേക്ക് അടയാളപ്പെടുത്തുക എന്ന വലിയ ഉത്തരവാദിത്തം കൂടി ഞങ്ങൾ നെഞ്ചേറ്റുന്നു.
                                </p>
                                <p className="lead fw-normal text-muted mb-4">
                                    മനുഷ്യപുരോഗതിയുടെ അടിസ്ഥാനം വിജ്ഞാനമാണെന്നും അതിലേക്കുള്ള ഏറ്റവും മികച്ച വഴി പുസ്തകങ്ങളാണെന്നും ഞങ്ങൾ വിശ്വസിക്കുന്നു. ആ തിരിച്ചറിവിൽ നിന്നാണ് ഒരു സാംസ്കാരിക കൂട്ടായ്മ എന്ന നിലയിൽ ഉയിർമൊഴി രൂപമെടുത്തത്. പ്രീമിയം ഗ്രന്ഥങ്ങളിലൂടെ വായനക്കാരുടെ സൃഷ്ടിപരമായ കഴിവുകൾ വർദ്ധിപ്പിക്കാനും, ചിന്താശീലരായ ഒരു പുതിയ സമൂഹത്തെ വാർത്തെടുക്കാനുമുള്ള സ്വപ്നങ്ങളാണ് ഈ സംരംഭത്തിന് പിന്നിലെ ചാലകശക്തി.
                                </p>
                            </div>

                        </div>
                    </div>
                    <div className='row ml-10'>
                        <ul className='text-left custom-logo-list'>
                            <li>പുസ്തകങ്ങൾ വഴി അറിവും സംസ്കാരവും പ്രചരിപ്പിക്കുക</li>
                            <li>നഷ്ടപ്പെട്ടുപോയ ഗ്രന്ഥങ്ങൾ വീണ്ടെടുത്ത് പ്രസിദ്ധീകരിക്കുക.</li>
                            <li>ബാലസാഹിത്യം, വൈജ്ഞാനികസാഹിത്യം, ചരിത്രം എന്നിവ അതിവ പ്രാധാന്യത്തോടെ പ്രസിദ്ധീകരിക്കുകയും പ്രചരിപ്പിക്കുകയും ചെയ്യുക.</li>
                            <li>പുസ്തകവായനയുടെ പ്രാധാന്യം പ്രചരിപ്പിക്കുക.</li>
                            <li>പുസ്തക ചർച്ചയും സാംസ്കാരിക ചർച്ചയും സംഘടിപ്പിക്കുക.</li>
                            <li>മലയാളത്തിന് അന്യമായിക്കൊണ്ടിരിക്കുന്ന നാടൻകലകളെയും ഗോത്രകലകളെയും സംരക്ഷിക്കുകയും പ്രോത്സാഹിപ്പിക്കുകയും ചെയ്യുക.</li>
                        </ul>
                    </div>
                </div>
            </header>
            <section className="py-2 bg-light" id="scroll-target">
                <div className="container px-5 my-5">
                    <div className="row gx-5 align-items-center">
                        <h2 className="fw-bolder text-center cherry-red-heading">ഉയിർമൊഴിയുടെ ആരംഭം</h2>
                        <div className="col-lg-6"><img className="img-fluid rounded mb-5 mb-lg-0" src={a1} alt="Uyirmozhy History and Books" /></div>
                        <div className="col-lg-6">
                            <p className="lead fw-normal text-muted mb-0 pb-2">
                                2017-ല്‍ തിരുവനന്തപുരം ജില്ലയില്‍ വെഞ്ഞാറമൂട് ആസ്ഥാനമാക്കി ആരംഭിച്ച ഒരു കൂട്ടായ്മയാണ് ഉയിർമൊഴി പ്രതിഷ്ഠാനം. മലയാള ഭാഷയേയും അതിൻ്റെ പൈതൃക സംസ്കാരത്തേയും കുറിച്ച് പഠിക്കാനും പ്രചരിപ്പിക്കാനും അതുവഴി, കല, ഭാഷ, സംസ്കാരം എന്നിവയിലെ മുല്യവത്തായ വസ്തുതകളെ ആലേഖനംചെയ്ത് സൂക്ഷിക്കാനും ഉതകുന്ന തരത്തിൽ ഒരു കൂട്ടം വിജ്ഞാനകുതികികൾ ചേർന്ന് രൂപംകൊടുത്ത പ്രസ്ഥാനമാണ് ഉയിർമൊഴി പ്രതിഷ്ടാനം.രാജശ്രീ സജീവ് (ചെയർമാൻ) ശ്രീ.ഗിരീഷ് വി.എസ് നായർ (ഗ്രാമീണൻ) സെക്രട്ടറി, വിനോദ് ഭാനുവിക്രമൻ ട്രഷറർ തുടങ്ങിയവർ ഉയിർമൊഴി പ്രതിഷ്ടാനത്തിനറെ അമരക്കാരായി. വിജ്ഞാനത്തിന് ഉതകുന്നതരത്തിൽ വായനാക്കൂട്ടവും സാംസ്കാരികവേദിയും ഉണ്ടാക്കി. ഒപ്പം എഴുത്തുകാർക്ക് ഒരു കൈത്താങ്ങായി  ഉയിർമൊഴി പബ്ലിക്കേഷൻ വിഭാഗവും. ഗ്രാമീണനാണ് പ്രസാധകന്റെയും മാനേജിംഗ് എഡിറ്ററുടെയും ചുമതല.
                            </p>
                        </div>
                        {/* <p className="lead fw-normal text-muted mb-0">
                            വിജ്ഞാനത്തിന് ഉതകുന്നതരത്തിൽ വായനാക്കൂട്ടവും സാംസ്കാരികവേദിയും ഉണ്ടാക്കി. ഒപ്പം എഴുത്തുകാർക്ക് ഒരു കൈത്താങ്ങാകുക എന്ന ലക്ഷ്യത്തോടെ ആരംഭിച്ചതാണ് ഉയിർമൊഴി പബ്ലിക്കേഷൻ വിഭാഗം. ഉയിർമൊഴി പ്രതിഷ്ടാനത്തിൻ്റെ  പൂർണ്ണ നിയന്ത്രണത്തിലും മേൽനോട്ടത്തിലുമാണ് പബ്ലിക്കേഷൻ പ്രവർത്തിക്കുന്നത്. സെക്രട്ടറിയായ  ഗ്രാമീണനാണ് പ്രസാധകനും മാനേജിംഗ് എഡിറ്ററും.
                        </p> */}
                    </div>
                </div>
            </section>
            <section className="">
                <div className="container px-5 my-5">
                    <div className="row gx-5 align-items-center">
                        <h2 className="fw-bolder cherry-red-heading">ഉയിർമൊഴിയുടെ ആദ്യ പുസ്തകവും തുടർപ്രവർത്തനങ്ങളും</h2>
                        <div className="col-lg-6 order-first order-lg-last"><img className="img-fluid rounded mb-5 mb-lg-0" src={a2} alt="Growth of Uyirmozhy Publications" /></div>
                        <div className="col-lg-6">
                            <p className="lead fw-normal text-muted mb-0 pb-2 text-justify">
                                2025 ജൂൺ 18 ന് കവിയും കഥാകാരിയുമായ പ്രിയാഉദയൻ്റെ ആദ്യ കഥാസമാഹാരം ഉയിർമൊഴിയുടെ ആദ്യ പുസ്തകമായി പുറത്തിറങ്ങി. തുടർന്ന് ഇടതടവില്ലാതെ അനേകമനേകം പ്രശസ്തരുടെയും  പുതിയ തലമുറയിലെ എഴുത്തുകാരുടെയും പുസ്‌തകങ്ങൾ അവരുടെ എഴുത്തിന്റെ മൂല്യം ഒട്ടും ചോര്‍ന്നുപോകാതെ പ്രസിദ്ധീകരിക്കുന്നു. വിറ്റുപകുന്ന പുസ്തകങ്ങൾക്ക് അപ്പപ്പോൾത്തന്നെ റോയല്‍റ്റിയും നൽകുന്നു.  പ്രതിമാസ ചർച്ചയും സാംസ്കാരിക വേദിയിലൂടെ സംഘടിപ്പിക്കുന്നു. പുസ്തകോത്സവങ്ങളിലും മറ്റും പങ്കെടുത്ത് വായനക്കാരെ തങ്ങളിലേക്കെത്തിക്കാൻ സദാ പ്രയത്നിക്കുന്നു.  കഴിയുന്നിടത്തോളം വായനക്കാരിലേക്ക് പുസ്തകങ്ങൾ എത്തിക്കുകയും സാമൂഹിക സാംസ്കാരികവിഷയങ്ങളും നാടൻകലകളും ചർച്ചക്ക് വിധേയമാക്കുകയും ചെയ്യുന്നു.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5 bg-light">
                <div className="container px-5 my-5">
                    <div className="text-center">
                        <h2 className="fw-bolder">നമ്മുടെ സംഘം</h2>
                        <p className="lead fw-normal text-muted mb-5">
                            ഗ്രന്ഥപ്രസിദ്ധീകരണത്തിനുള്ള സമർപ്പിത ടീം
                        </p>
                    </div>
                    <div className="row gx-5 row-cols-1 row-cols-sm-2 row-cols-xl-4 justify-content-center">
                        <div className="col mb-5 mb-5 mb-xl-0">
                            <div className="text-center">
                                <img className="img-fluid rounded-circle mb-4 px-4" src={IMG_BASE_URL + "team/rajasree.jpg"} alt="Rajasree Sajeev - Chairman" />
                                <h5 className="fw-bolder">രാജശ്രീ സജീവ്</h5>
                                <div className="fst-italic text-muted">ചെയർമാൻ</div>
                            </div>
                        </div>
                        <div className="col mb-5 mb-5 mb-xl-0">
                            <div className="text-center">
                                <img className="img-fluid rounded-circle mb-4 px-4" src={IMG_BASE_URL + "team/grameenan.jpg"} alt="Grameenan - Publisher" />
                                <h5 className="fw-bolder">ഗ്രാമീണൻ</h5>
                                <div className="fst-italic text-muted">പ്രസാധകൻ / മാനേജിംഗ് എഡിറ്റർ</div>
                            </div>
                        </div>
                        <div className="col mb-5 mb-5 mb-sm-0">
                            <div className="text-center">
                                <img className="img-fluid rounded-circle mb-4 px-4" src={IMG_BASE_URL + "team/vinod.jpg"} alt="Vinod Bhanuvikraman - Treasurer" />
                                <h5 className="fw-bolder">വിനോദ് ഭാനുവിക്രമൻ</h5>
                                <div className="fst-italic text-muted">ട്രഷറർ</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
